import { GetProcessParam } from "./ProcessParams";

export const getSensorTypeList = () => {
  return ["lidarDx", "lidarSx", "pesogr", "pesogr2", "rumore", "door"];
};

const defaultSensorTooltipMap: any = {
  falseAlarm: "Allarme rientrato",
  lidarAggregated: "Tentativo di alzata",
  lidarDx: "Tentativo di alzata dx",
  lidarSx: "Tentativo di alzata sx",
  pesogr: "Fuori dal letto",
  pesogr2: "Bilancia",
  rumore: "Rumori d'ambiente",
  door: "Porta aperta",
};

export const getSensorIconTooltip = (type: string) => {
  let tradMap = defaultSensorTooltipMap;
  let tradVoice = tradMap[type];

  let fromParams = GetProcessParam("REACT_APP_SENSOR_TRAD_" + type);
  if (fromParams) {
    tradVoice = fromParams;
  }

  let tooltip = tradVoice ? tradVoice : "<?>";
  return tooltip;
};

export const getSensorIconName = (type: string) => {
  let tooltip = "";
  switch (type) {
    case "lidarDx":
      tooltip = "Redo";
      break;
    case "lidarSx":
      tooltip = "Undo";
      break;
    case "pesogr":
      tooltip = "Running";
      break;
    case "pesogr2":
      tooltip = "Running";
      break;
    case "rumore":
      tooltip = "Megaphone";
      break;
    case "door":
      tooltip = "OutOfOffice";
      break;
  }
  return tooltip;
};
